import type { Sticker } from "../api/StickersAPI"

export function renderStickerCard(sticker: Sticker): HTMLElement {

  const discount = Math.round(
  (1 - sticker.discounted_price_uah / sticker.full_price_uah) * 100
  )
  const card = document.createElement("div")
  card.className = "sticker-card"

  card.innerHTML = `

    <h3 class="sticker-title">
      ${sticker.title}
    </h3>

      <div class="sticker-description">
        ${sticker.description}
      </div>

      <div class="sticker-spacer"></div>

      <div class="price-block">

          <div class="price-full">
            ${sticker.full_price_uah} грн
          </div>

          <div class="price-discount">

            ${sticker.discounted_price_uah} грн

            <span class="discount-badge">
              -${discount}%
            </span>

          </div>

        </div>

    <button class="subscribe-button">
      ${sticker.payment_description}
    </button>

  `

    const button = card.querySelector("button")!

    button.addEventListener("click", () => {

      // Берем все параметры текущего Landing
      const params = new URLSearchParams(window.location.search)

      // auth — служебный параметр приложения, если вдруг есть на Landing,
      // убираем его, чтобы потом добавить один раз.
      params.delete("auth")

      // Формируем URL приложения
      const url = new URL("https://app.fr.bezbolu.pro/")

      // Служебные параметры приложения
      url.searchParams.set("auth", "")
      url.searchParams.set("sticker", sticker.sticker_id)

      // Переносим все остальные параметры (utm, partner и т.д.)
      for (const [key, value] of params.entries()) {
        url.searchParams.set(key, value)
      }

      window.location.href = url.toString()

    })

  return card
}